import prettifyXml from 'prettify-xml';
import hljs from 'highlight.js/lib/highlight';
import hljsXML from 'highlight.js/lib/languages/xml';
hljs.registerLanguage('xml', hljsXML);

angular.module('TInv.dir.xmltree', []
).directive('xmlTree', function ($sce) {
    // inspired from from: http://plnkr.co/edit/ECdIBX6GGQycw1tg5Xw7?p=preview
    return {
        restrict: 'E',
        scope: {
            model: '=',
        },
        template: '<pre ng-bind-html="html" style="overflow: auto;" class="hljs"></pre>',
        controller: function ($scope) {
            $scope.$watch('model', function () {
                var out = $scope.model;
                out = prettifyXml(out);
                out = hljs.highlight('xml', out).value;
                $scope.html = $sce.trustAsHtml(out);
            });
        }
    };
});
